var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading)?_c('div',{staticClass:"auth"},[_c('public-header'),_c('v-main',{staticClass:"content"},[_c('router-view')],1),_c('public-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }